module.exports = __webpack_public_path__ + "assets/img/block-left-e0c19e5c.png";